import { EAuthUserAccountType } from '../../../types/rest/IRestAuthUser';
import {IApplicationState} from '../../../types/types';
import { getAuthUser } from '../authUser/selectors/getAuthUser';

export const getUserAccountType = (
    state: IApplicationState
): EAuthUserAccountType => {
    return getAuthUser(state) && getAuthUser(state).accountType;
};
